import { Box, Theme, useTheme } from '@mui/material';
import { Subheading, Subtitle } from '../../components/shared/typography/PrimaryTypography';
import { ReactComponent as ErrorIcon } from '../../assets/icons/Error.svg';
import { Refresh } from '@mui/icons-material';
import PrimaryButton from '../../components/shared/button/PrimaryButton';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import GhostButton from '../../components/shared/button/GhostButton';

/**
 * Default error boundary view for unhandled exceptions wrapping all app routes.
 * @returns {JSX.Element}
 */
const DefaultErrorBoundary = () => {
  const theme: Theme = useTheme();
  const navigate: NavigateFunction = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        minHeight: '70vh'
      }}
    >
      <ErrorIcon height={100} fill={theme.palette.primary.main} />
      <Subtitle weight="Bold">Oops! Something went wrong</Subtitle>
      <Subheading weight="Medium" sx={{ my: 4, maxWidth: '50%' }}>
        Sorry, an unexpected error occurred. Please try refreshing the page or contacting the
        Syntiro team if the issue persists.
      </Subheading>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <GhostButton dark onClick={() => window.location.reload()} startIcon={<Refresh />}>
          Refresh Page
        </GhostButton>
        <PrimaryButton onClick={() => navigate('/contact')}>Contact Syntiro Team</PrimaryButton>
      </Box>
    </Box>
  );
};

export default DefaultErrorBoundary;
